import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageview } from '@/shared/lib/analytics'
import { gtagPageview } from '@/shared/lib/gtag'

/**
 * Fires a pageview every time the route changes. The first navigation
 * (initial mount) also fires. The analytics layer is a no-op when no
 * endpoint is configured, so this hook is safe to call unconditionally.
 * Also forwards to Google Analytics 4 (G-WHZW7ZWWWY) for SPA routing.
 */
export function usePageview() {
  const location = useLocation()
  useEffect(() => {
    const path = location.pathname + location.search
    trackPageview(path)
    gtagPageview(path)
  }, [location.pathname, location.search])
}
